import {
    REGISTRATION_WIZARD_CONTROL_VARIANT,
    REGISTRATION_WIZARD_TREATMENT_VARIANT,
    registrationWizardAbTest
} from "../../ab_testing/registration_wizard_ab_test";
import {IBinaryExperiment, IBinaryExperimentConfig, useBinaryExperiment} from "./use_binary_experiment";

interface IUseRegistrationWizardExperimentParams {
    isEnabled: boolean;
}

const registrationWizardExperimentConfig: IBinaryExperimentConfig = {
    abTest: registrationWizardAbTest,
    controlVariant: REGISTRATION_WIZARD_CONTROL_VARIANT,
    treatmentVariant: REGISTRATION_WIZARD_TREATMENT_VARIANT
};

/** The stepped registration wizard in place of the legacy authentication modals */
export const useRegistrationWizardExperiment = ({isEnabled}: IUseRegistrationWizardExperimentParams): IBinaryExperiment =>
    useBinaryExperiment(registrationWizardExperimentConfig, {isEnabled});
import {
    REGISTRATION_WIZARD_CONTROL_VARIANT,
    REGISTRATION_WIZARD_TREATMENT_VARIANT,
    registrationWizardAbTest
} from "../../ab_testing/registration_wizard_ab_test";
import {IBinaryExperiment, IBinaryExperimentConfig, useBinaryExperiment} from "./use_binary_experiment";

interface IUseRegistrationWizardExperimentParams {
    isEnabled: boolean;
}

const registrationWizardExperimentConfig: IBinaryExperimentConfig = {
    abTest: registrationWizardAbTest,
    controlVariant: REGISTRATION_WIZARD_CONTROL_VARIANT,
    treatmentVariant: REGISTRATION_WIZARD_TREATMENT_VARIANT
};

/** The stepped registration wizard in place of the legacy authentication modals */
export const useRegistrationWizardExperiment = ({isEnabled}: IUseRegistrationWizardExperimentParams): IBinaryExperiment =>
    useBinaryExperiment(registrationWizardExperimentConfig, {isEnabled});
